<template>
	<v-row>
		<v-col v-for="tile in tiles" :key="tile.title" cols="12" sm="3">
			<v-card
				class="tile"
				:class="{ 'tile-mobile': $vuetify.breakpoint.xsOnly }"
				@click="$emit('click:tile', tile.route)"
			>
				<v-card-text class="tile-image">
					<v-img
						v-if="tile.image"
						:src="tile.image"
						:height="$vuetify.breakpoint.xsOnly ? 100 : 200"
						contain
					/>
					<v-icon v-else :size="$vuetify.breakpoint.xsOnly ? 75 : 120">{{
						tile.icon
					}}</v-icon>
				</v-card-text>
				<v-card-title class="tile-title justify-center">{{
					tile.title
				}}</v-card-title>
			</v-card>
		</v-col>
	</v-row>
</template>

<style lang="scss" scoped>
.tile {
	.tile-image {
		text-align: center;
	}

	.tile-title {
		word-break: normal;
		text-align: center;
	}

	&.tile-mobile .tile-title {
		font-size: 24px;
	}
}
</style>

<script>
export default {
	props: {
		tiles: {
			type: Array,
			required: true,
		},
	},
};
</script>
